<template>
  <div class="page" :class="{ page_fill: videoConf.fullScreen }">
    <div id="container"></div>
    <div class="loading" v-if="videoState != 2">
      <img src="../assets/image/loading.png" alt="" />
      <p>正在加载中…</p>
    </div>
    <img
      src="../assets/image/player.png"
      v-if="isH5 && isPlayer"
      @click="tapPlayer"
      class="play-1125"
      alt=""
    />
    <div
      :class="{ ptz: true, ptz_fill: videoConf.fullScreen }"
      @touchstart="touchstartClick"
      @touchend="touchEnd"
      ref="ptz"
      :style="{ display: videoConf.showPzt ? 'block' : 'none' }"
    >
      <img
        class="translucent"
        src="../assets/image/translucent.png"
        draggable="false"
        alt=""
      />
      <img
        v-if="!videoConf.fullScreen"
        class="up"
        :style="{ display: moveDirection === '1' ? 'block' : 'none' }"
        src="../assets/image/up.png"
        draggable="false"
        alt=""
      />
      <img
        v-else
        class="up"
        :style="{ display: moveDirection === '3' ? 'block' : 'none' }"
        src="../assets/image/up.png"
        draggable="false"
        alt=""
      />
      <img
        v-if="!videoConf.fullScreen"
        class="down"
        :style="{ display: moveDirection === '2' ? 'block' : 'none' }"
        src="../assets/image/down.png"
        draggable="false"
        alt=""
      />
      <img
        v-else
        class="down"
        :style="{ display: moveDirection === '4' ? 'block' : 'none' }"
        src="../assets/image/down.png"
        draggable="false"
        alt=""
      />
      <img
        v-if="!videoConf.fullScreen"
        class="right"
        :style="{ display: moveDirection === '4' ? 'block' : 'none' }"
        src="../assets/image/right.png"
        draggable="false"
        alt=""
      />
      <img
        v-else
        class="right"
        :style="{ display: moveDirection === '1' ? 'block' : 'none' }"
        src="../assets/image/right.png"
        draggable="false"
        alt=""
      />
      <img
        v-if="!videoConf.fullScreen"
        class="left"
        :style="{ display: moveDirection === '3' ? 'block' : 'none' }"
        src="../assets/image/left.png"
        draggable="false"
        alt=""
      />
      <img
        v-else
        class="left"
        :style="{ display: moveDirection === '2' ? 'block' : 'none' }"
        src="../assets/image/left.png"
        draggable="false"
        alt=""
      />
    </div>
    <img
      src="@/assets/image/speak.png"
      class="speak_fill"
      :style="{ display: videoConf.fullScreen ? 'block' : 'none' }"
    />


    <div
        class="sensor-list"
        v-if="sensorList.length > 0"
        ref="sensorListRef"
        @scroll="handleListScroll"
    >
      <!-- 给整个item框添加条件事件：仅expTimeStatus=0时触发handleLightClick -->
      <div
          class="sensor-item"
          v-for="item in sensorList"
          :key="item.itemsId"
          @click="item.expTimeStatus === 0 ? handleLightClick(item) : null"
          :class="{ 'clickable-item': item.expTimeStatus === 0 }"
      >
        <div class="sensor-label">{{ item.deviceMac }}</div>
        <div class="sensor-temp" :class="getTempClass(item.temperatureStatus)">
          {{ item.temperature > 0 ? item.temperature : 0 }}℃
        </div>
        <div class="sensor-step">活动量：{{ item.stepCountSum }}</div>
        <!-- 保留原有状态展示 -->
        <div class="sensor-status">
          <button
              v-if="item.expTimeStatus === 0"
              class="status-btn online"
              :disabled="isPolling"
          >
            <i class="light-icon"></i> {{ isPolling && isPollingId===item.itemsId? '查找中...' : '查找' }}
          </button>
          <div v-else class="status-text offline">离线</div>
        </div>
      </div>
      <!-- 加载中提示 -->
      <div class="load-tips" v-if="isLoading">加载中...</div>
    </div>

    <div
      class="operation fixed-bottom"
      :class="{ operation_fill: videoConf.fullScreen }"
    >
      <img
        :src="definitionImage"
        @click="hd"
        :style="{ display: controls.includes('hd') ? 'block' : 'none' }"
        class="hd"
      />
      <div class="huif cute" @click="cute">回放</div>
      <img
        src="../assets/image/speak.png"
        @click="speak"
        :style="{ display: controls.includes('speak') ? 'block' : 'none' }"
        class="speak"
        v-if="!videoConf.audio"
      />
      <img
        v-else
        src="../assets/image/speaking.png"
        @click="speak"
        :style="{ display: controls.includes('speak') ? 'block' : 'none' }"
        class="speak"
      />
      <img
        src="../assets/image/Mute.png"
        @click="Mute"
        :style="{ display: controls.includes('Mute') ? 'block' : 'none' }"
        class="Mute"
        v-if="!videoConf.mute"
      />
      <img
        v-else
        src="../assets/image/Mute1.png"
        @click="Mute"
        :style="{ display: controls.includes('Mute') ? 'block' : 'none' }"
        class="Mute"
      />
      <img
        src="../assets/image/ptzclose.png"
        @click="ptzclose"
        :style="{ display: controls.includes('ptzclose') ? 'block' : 'none' }"
        class="ptzclose"
      />
      <img
        :src="!videoConf.fullScreen ? fullscreenImage : closefullscreenImage"
        @click="screen"
        :style="{ display: controls.includes('screen') ? 'block' : 'none' }"
        class="screen"
      />
    </div>
    <div class="picker-model" v-if="showPicker">
      <van-picker
        title="请选择子设备"
        :columns="devList"
        :value-key="'DevName'"
        :item-height="'70px'"
        :visible-item-count="8"
        :default-index="channelIndex"
        @change="channelChange"
      />
      <div class="btn-box">
        <div class="cancel-btn" @click="cancel">取消</div>
        <div class="confirm-btn" @click="confirm">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
import fullscreenImage from "@/assets/image/screen.png";
import closefullscreenImage from "@/assets/image/fullscreen.png";
import {
  getMultiMediaAddr,
  setSysCommand,
  openTalk,
  getSubDeviceList,
} from "../api/api";
import {
  moveDeviceApi,
  setAdjustFocalLengthApi,
  noticeDeviceUploadPicRequestApi,
  getUserMacsEquipmentsApi,
  // 新增：亮灯相关接口（需替换为你的实际接口）
  controlLightApi2, getOpenLightUserinfoApi2, getOpenLightResultApi2,
} from "../api/custom";
import hdImage from "@/assets/image/hd.png";
import fhdImage from "@/assets/image/fhd.png";
export default {
  name: "HMPalyer",
  data() {
    return {
      serverDomain: "https://testopenlink.smartcloudcon.com",
      appSecret: "G021l7egdug5w4txoz4frfs4y4ywowp5",
      appKey: "G021l7egdug5w4tx",
      utoken: "",
      devList: [
        {
          DevName: "智能设备12",
          value: 1,
        },
        {
          DevName: "智能设备2",
          value: 2,
        },
        {
          DevName: "智能设备3",
          value: 3,
        },
        {
          DevName: "智能设备4",
          value: 4,
        },
        {
          DevName: "智能设备5",
          value: 5,
        },
      ],
      showPicker: false,
      fullscreenImage,
      closefullscreenImage,
      hdImage,
      fhdImage,
      moveDirection: "5",
      controls: ["hd", "cute", "speak", "Mute", "screen"],
      videoConf: {
        definition: "fhd",
        audio: false,
        fullScreen: false,
        showPzt: true,
        player: undefined,
        mediaType: 1,
        mute: false, //声音
      },
      player: null,
      ChannelNum: 0, //通道号
      channelIndex: 0,
      channelData: {},
      DevName: "大门", // 设备名称
      CTEI: "", // 设备唯一标识
      mediaData: {},
      ptz: null,
      did: "", // 设备id
      videoState: 1, //当前播放器状态
      isIOS: false,
      containerStyle: {},
      isH5: false,
      isPlayer: true,
      isplayBack:false,

      // 传感器列表核心配置
      sensorList: [],
      equipmentId: 0,
      page: 1,
      limit: 5,
      isLoading: false,
      noMore: false,
      loadTriggered: false, // 防止重复触发加载
      token:"",

      // 亮灯查找核心配置（复刻uni-app逻辑）
      isPolling: false, // 是否正在轮询
      isPollingId: '', // 是否正在轮询
      pollingTimer: null, // 轮询定时器ID
      timeoutTimer: null, // 超时定时器ID
      curViewUser: "", // 当前查看亮灯的用户
      linkMonitorLicense: null, // 关联的监控设备license
      curOrderUser: "", // 当前下单用户（根据你的业务调整）
      pollingCount: 0, // 轮询次数计数（用于兜底）
    };
  },
  components: {
    // 'vant-button': Button
  },
  computed: {
    definitionImage() {
      return this[`${this.videoConf.definition}Image`];
    },
  },
  beforeDestroy() {
    console.log("======================----==2");
    this.getPicRequest();
    if(!this.isplayBack)this.player.destroy();
    // 新增：清理轮询定时器
    this.stopPolling();
  },
  async created() {
    //获取页面url参数
    let { uid, ctei, did, ChannelNum, DevName, isH5 , equipmentId ,token} = this.$route.query;
    if (token) this.token = token;
    if (equipmentId) this.equipmentId = equipmentId;
    if (uid) {
      this.uid = uid;
    }
    if (ctei) {
      this.CTEI = ctei;
      //检查机型
      this.checkDevice();
    }
    if (isH5) {
      this.isH5 = true;
      this.videoState = 2;
    }
    if (did) {
      this.did = did;
    }
    if (ChannelNum) {
      this.ChannelNum = ChannelNum;
      this.getSubDeviceList();
    }
    if (DevName) {
      this.DevName = DevName;
    }
    if (equipmentId > 0) {
      console.log("****普通用户加载列表数据****");
      this.getSensorList();
    }
  },
  mounted() {
    if (!this.isH5) this.getMultiMediaAddress();
    this.ptz = document.getElementsByClassName("ptz")[0]; //获取ptz
    this.ptz.addEventListener('touchstart', this.touchstartClick, false)
  },

  methods: {
    // 亮灯按钮点击事件
    async handleLightClick(item) {
      if (this.isPolling) {
        this.$showToast(
            '提示',
            '正在查找中，请稍候...',
            'success',
            3000
        );
        return; // 防止重复点击
      }
      console.log("触发亮灯操作，设备信息：", item);

      // 1. 记录关联的license
      this.linkMonitorLicense = item.linkMonitorLicense || this.CTEI;
      if (!this.linkMonitorLicense) {
        this.$showToast(
            '提示',
            '设备license为空，无法执行亮灯操作',
            'warning',
            3000
        );
        return;
      }

      console.log(" this.linkMonitorLicense：",  this.linkMonitorLicense);
      console.log(" item.deviceMac：",  item.deviceMac);
      console.log(" this.curOrderUser：",  this.curOrderUser);
      console.log(" this.token：",  this.token);

      try {
        // 2. 调用亮灯接口
        const res = await controlLightApi2({
          license: this.linkMonitorLicense,
          deviceMac: item.deviceMac,
          curOrderUser: this.curOrderUser,
        }, this.token);

        if (res.code === 200) {
          console.log("亮灯接口返回结果：", res, this.isPolling);
          this.isPolling = true; // 标记开始轮询
          this.isPollingId = item.itemsId;
          this.pollingCount = 0; // 重置轮询计数

          // 3. 先加载用户信息，再启动轮询
          await this.loadCurLightUser(2,item.itemsId);

          // 4. 启动轮询（每隔2秒查一次）+ 30秒超时控制
          this.startPolling(item.deviceMac,item.itemsId);
        } else {
          console.log("亮灯接口异常1：", res.message)
          this.$showToast(
              '失败',
              res.message || "查找操作失败，请稍后重试",
              'error',
              3000
          );
        }
      } catch (err) {
        console.log("亮灯接口异常2：", err)
        this.isPolling = false; // 异常时重置状态
        this.isPollingId = '';
        this.$showToast(
            '失败',
            err || "查找操作失败，请稍后重试",
            'error',
            3000
        );
      }
    },

// 启动轮询查询亮灯结果
    startPolling(mac) {
      // 清除已有定时器（防止重复）
      if (this.pollingTimer) clearInterval(this.pollingTimer);
      if (this.timeoutTimer) clearTimeout(this.timeoutTimer);

      // 立即执行第一次查询
      this.doLoadResult(mac);

      // 1. 每隔2秒轮询一次
      this.pollingTimer = setInterval(() => {
        this.doLoadResult(mac);
        this.pollingCount++;
      }, 2000);

      // 2. 30秒超时兜底（强制停止轮询）
      this.timeoutTimer = setTimeout(() => {
        this.stopPolling();
        this.$showToast(
            '请重试',
            "查找超时",
            'error',
            3000
        );
      }, 30 * 1000);
    },

// 停止轮询（通用清理方法）
    stopPolling() {
      this.isPolling = false;
      this.isPollingId = '';
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
      if (this.timeoutTimer) {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = null;
      }
      this.pollingCount = 0; // 重置计数
      console.log("轮询已停止");
    },

// 获取当前亮灯用户
    async loadCurLightUser(i,itemsId) {
      try {
        if (!this.linkMonitorLicense) {
          console.log('linkMonitorLicense为空');
          return;
        }

        const res = await getOpenLightUserinfoApi2({
          license: this.linkMonitorLicense,
        },this.token);

        if (res.data?.isView) {
          this.curViewUser = res.data.nickname;
        } else {
          this.curViewUser = "";
          if (i === 2) {
            this.$showToast(
                '提示',          // 标题
                '没有人在查看', // 内容
                'success',       // 类型（警告）
                3000             // 4秒后自动关闭（可选，默认3秒）
            );
          }
        }

        // 如果是自己在查看，且未开始轮询，则启动轮询（兼容原有逻辑）
        if (res.data?.isOwn && !this.isPolling) {
          console.log('轮询查询亮灯状态');
          this.isPolling = true;
          this.isPollingId = itemsId;
          this.startPolling(res.data.mac);
        }
      } catch (err) {
        this.stopPolling(); // 异常时停止轮询
        console.error("获取亮灯用户失败：", err);
        this.$showToast(
            '失败',          // 标题
            '获取查找用户失败', // 内容
            'error',       // 类型（警告）
            3000             // 4秒后自动关闭（可选，默认3秒）
        );
      }
    },

// 查询亮灯结果（核心：有结果立即停止轮询）
    async doLoadResult(mac) {
      if (!this.linkMonitorLicense || !this.isPolling) {
        console.log('linkMonitorLicense为空或未在轮询状态');
        return;
      }

      try {
        const res = await getOpenLightResultApi2({
          license: this.linkMonitorLicense,
          deviceMac: mac,
        },this.token);

        // 情况1：有明确结果（成功/失败）
        if (res.data && res.data.isSucc !== null) {
          this.stopPolling(); // 立即停止轮询
          const msg = res.data.isSucc ? '已找到，请留意亮灯！' : '查找失败';
          this.$showToast(
              '已找到',
              msg,
              'success',
              3000
          );
          return;
        }

        // 情况2：暂无结果，继续轮询
        console.log(`第${this.pollingCount + 1}次轮询：获取亮灯结果，暂无结果`);

      } catch (err) {
        console.error(`第${this.pollingCount + 1}次轮询查询亮灯结果失败：`, err);
        // 单个请求失败不停止轮询，直到超时
      }
    },
    // 温度状态样式
    getTempClass(status) {
      if (status === 1) return "temp-low";
      if (status === 2) return "temp-high";
      return "";
    },

    // 监听滚动事件，触底加载下一页
    handleListScroll() {
      const listDom = this.$refs.sensorListRef;
      if (!listDom || this.isLoading || this.noMore || this.loadTriggered) return;

      // 计算滚动是否到底部（左滑触底）
      const { scrollLeft, scrollWidth, clientWidth } = listDom;
      const isBottom = scrollLeft + clientWidth >= scrollWidth - 20; // 20px容错，提前触发

      if (isBottom) {
        this.loadTriggered = true; // 标记已触发，防止重复
        console.log("左滑触底，触发加载下一页");
        this.page++;
        this.getSensorList().finally(() => {
          this.loadTriggered = false; // 加载完成后重置
        });
      }
    },
    // 获取传感器列表数据
    async getSensorList() {
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        const params = {
          page: this.page,
          limit: this.limit,
          license: this.CTEI,
          equipmentId: this.equipmentId,
        };
        const res = await getUserMacsEquipmentsApi(params);
        const list = res.data?.list || [];
        const total = res.data?.total || 0;

        // 拼接分页数据
        if (this.page === 1) {
          this.sensorList = list;
        } else {
          this.sensorList = [...this.sensorList, ...list];
        }

        console.log(`第${this.page}页加载完成，当前列表长度：${this.sensorList.length}，总数据量：${total}`);
        // 判断是否无更多数据
        this.noMore = this.sensorList.length >= total;
      } catch (err) {
        console.error("获取传感器列表失败：", err);
      } finally {
        this.isLoading = false;
      }
    },

    tapPlayer() {
      this.videoState = 1;
      this.isPlayer = false;
      this.getMultiMediaAddress();
    },

    //通知抓图
    getPicRequest() {
      noticeDeviceUploadPicRequestApi({
        gifFlag: 2,
        license: this.CTEI,
        picType: 1,
      });
    },
    // 检查设备类型
    checkDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (
        userAgent.match(/iPad/i) ||
        userAgent.match(/iPhone/i) ||
        userAgent.match(/iPod/i)
      ) {
        this.isIOS = true;

      } else if (userAgent.match(/Android/i)) {
        this.isIOS = false;
      }
    },



    getMultiMediaAddress() {
      //  用户请求设备流媒体服务
      let data = {
        METHOD: "2216",
        SEQID: "10001",
        CTEI: this.CTEI, // 设备唯一ID
        BODY: {
          Proto: "1", // 媒体的请求协议： 0-TCP，1-WebSocket
          ChannelNum: this.ChannelNum || 0, // 通道号
        },
      };
      console.log(data, 2216);
      getMultiMediaAddr(data, this.serverDomain, this.appSecret, this.appKey)
        .then((res) => {
          console.log(res, "77777");
          if (res.data.CODE == 0) {
            this.mediaData = res.data.BODY;
            this.play(res.data.BODY);
          } else {
            console.log("errCode:" + res.data.CODE);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //播放
    play(videoUrl) {
      console.log(videoUrl);
      if (this.player) {
        this.player.destroy();
      }

      let deviceCode = this.did;
      let container = document.getElementById("container");
      console.log(container, "container===============");
      let options = {
        container: container,
        delay: 500,
        width: container.offsetWidth,
        height: container.offsetHeight,
        x: 0,
        y: 300,
        logEnable: true,
        logLevel: "debug",
        decoderMode: "soft-simd",
        useOffScreenCanvasRender: "true",
        useWorkerForMSE: true,
        renderMode: "mse", // 1.canvas 2.mse （video标签）
        audioEngine: "worklet",
        retryCnt: 0,
        disableAudioForMSE:true
      };
      const that = this;
      this.player = new HMWebPlayer(options);
      this.player.on("state", function ({ state }) {
        console.log(state, "state");
        if (state == 2) {
          that.videoState = state;

          //  判断当前是否是横屏
          if (that.videoConf.fullScreen) {
            let container = document.querySelector("#container");
            console.log(container, "container1");
            setTimeout(() => {
              let childNodes = container.children[0];
              childNodes.style.width = "100%";
              childNodes.style.height = "100%";
              childNodes.style.top = "0";
              childNodes.style.left = "0";
            }, 1500);
          }
        }
      });
      this.player.startHMLiveStream(
        "usertoken-a1234567890",
        deviceCode,
        videoUrl.WSUrl,
        videoUrl.ResourceID,
        49,
        videoUrl.EncKey,
        videoUrl.EncLoad,
        0,
        0,
        0,
        0
      );
      // this.videoConf.mediaType == 1 ? 1 : 0,
    },
    channelChange(e, val) {
      //监听通道的变化
      console.log(e, val);
      this.channelData = val;
    },
    cancel() {
      this.showPicker = false;
    },
    confirm() {
      //  确认选择通道重新播放
      //   this.channelData
      this.channelIndex = this.devList.findIndex(
        (item) => item.value == this.channelData.value
      );
      console.log(this.channelIndex);
      this.ChannelNum = this.channelData.value * 1;
      this.showPicker = false;
      this.getMultiMediaAddress();
    },
    // 点击时候触发的函数
    movebutton(arrow) {
      console.log(`点击了按钮${arrow}`);
      moveDeviceApi({
        license: this.CTEI,
        ptzControl: arrow,
        step:360,
        ptzType:0,
      });
     
      return;
      let params = {
        DID: this.did,
        Param: {
          METHOD: "3428",
          BODY: {
            PTZControl: arrow + "",
            PTZType: "0",
            Speed: "3",
            Step: "360",
          },
        },
      };
      setSysCommand(this.serverDomain, params);

    },
    moveEnd() {
      //停止ptz
      let params = {
        DID: this.did,
        Param: {
          METHOD: "3428",
          BODY: {
            PTZType: "3",
          },
        },
      };
      setTimeout(() => {
        moveDeviceApi({
        license: this.CTEI,
        ptzControl: this.moveDirection,
        step:360,
        ptzType:3,
      });
      }, 100);
      // setSysCommand(this.serverDomain, params);
      setTimeout(() => {
        this.moveDirection = "5";
      }, 500);
    },
    moveFill(e) {
      const ptz = this.$refs.ptz;

      let top = e.touches[0].clientY - ptz.getBoundingClientRect().top;
      let left = e.touches[0].clientX - ptz.getBoundingClientRect().left;
      let max_top = ptz.getBoundingClientRect().height;
      let max_left = ptz.getBoundingClientRect().width;
      // 上
      if (top < max_top / 2 && top < left && max_left - left > top) {
        if (this.moveDirection == "3") return;
        this.moveDirection = "3";
        this.movebutton("3", true);
        return;
      }
      // 下
      if (top > max_top / 2 && top > left && max_left - left < top) {
        if (this.moveDirection == "4") return;
        this.moveDirection = "4";
        this.movebutton("4", true);
        return;
      }
      // 左
      if (left < max_left / 2 && top > left && max_left - left > top) {
        if (this.moveDirection == "2") return;
        this.moveDirection = "2";
        this.movebutton("2", true);
        return;
      }
      // 右
      if (left > max_left / 2 && top < left && max_left - left < top) {
        if (this.moveDirection == "1") return;
        this.moveDirection = "1";
        this.movebutton("1", true);
        return;
      }
    },
    hd() {
      if (this.videoState != 2) {
        return;
      }
      this.videoConf.definition =
        this.videoConf.definition === "hd" ? "fhd" : "hd";
      console.log("按钮触发");
      if (this.videoConf.mediaType == 1) {
        this.videoConf.mediaType = 0;
      } else {
        this.videoConf.mediaType = 1;
      }
      this.videoState = 0;
      this.play(this.mediaData);
    },
    cute() {

      if (this.videoState != 2) {
        return;
      }
      this.isplayBack = true
      if (this.player) {
        this.player.destroy();
      }
     
        this.$router.push({
        path: "/playBack",
        query: {
          CTEI: this.CTEI,
          did: this.did,
          type: 1,
        },
      });
      return;
      //抓图
      let dataURL = "";
      console.log("按钮触发");
      let container = document.querySelector("#container");
      console.log(container, "container1");
      let childNodes = container.children[0];
      const video = childNodes;
      console.log();
      if (video.tagName == "VIDEO") {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");

        // 将视频的当前帧绘制到canvas上
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        // 将canvas内容转换为data URL
        dataURL = canvas.toDataURL("image/png");
      } else {
        video.toDataURL("image/png");
        dataURL = video.toDataURL("image/png");
      }

      // 你可以在这里使用dataURL，例如发送到服务器或进行其他操作
      console.log(dataURL);
      const a = document.createElement("a");
      a.href = dataURL;
      a.download = new Date().getTime() + ".png"; // 设置下载的文件名
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    speak() {
      if (this.videoConf.audio) {
        //  关闭对讲
        this.player.stopTalk();
        this.videoConf.audio = !this.videoConf.audio;
      } else {
        //开启对讲
        let data = {
          METHOD: "2310",
          SEQID: "10001",
          // 设备唯一ID
          BODY: {
            CTEIs: [this.CTEI],
            Proto: "1", // 媒体的请求协议： 0-TCP，1-WebSocket
          },
        };

        openTalk(data, this.serverDomain, this.appSecret, this.appKey).then(
          (res) => {
            if (res.data.CODE == 0) {
              let para = res.data.BODY;
              console.log(para, para.SessionID, "11");
              this.player.startTalk(
                para.WSUrl,
                para.SessionID,
                para.ResourceID,
                parseInt(para.EncType),
                para.EncKey,
                para.EncLoad
              );
              this.videoConf.audio = !this.videoConf.audio;
            }
          }
        );
      }

      console.log("按钮触发");
    },
    Mute() {
      if (this.videoState != 2) {
        return;
      }
      console.log("声音切换");
      if (this.videoConf.mute) {
        this.player.mute();
        // this.player.unMute()
        this.videoConf.mute = !this.videoConf.mute;
        // this.player.setVolume(0)
      } else {
        this.player.unMute();
        // this.player.setVolume(100)
        this.videoConf.mute = !this.videoConf.mute;
      }
    },
    ptzclose() {
      console.log("切换是否显示按钮触发");
      this.videoConf.showPzt = !this.videoConf.showPzt;
    },
    screen() {
      if (this.videoState != 2) {
        return;
      }
      let container = document.querySelector("#container");
      console.log(container, "container");
      let childNodes = container.children[0];

      let controls = this.controls;
      this.videoConf.fullScreen = !this.videoConf.fullScreen;
      this.videoConf.showPzt = !this.videoConf.fullScreen;
      if (this.videoConf.fullScreen) {
        controls.push("ptzclose");
        console.log("全屏");
        controls = controls.filter((e) => e !== "speak");
        container.style.height = "100vw";
        container.style.width = "100vh";
        container.style.transition = "all 0.3s ease-in-out 0s";
        container.style.transform = "rotate(90deg) translate(0px, -100%)";
        container.style.transformOrigin = "0px 0px";
        container.style.marginTop = "0";
        childNodes.style.width = "100%";
        childNodes.style.height = "100%";
        childNodes.style.top = "0";
        childNodes.style.left = "0";
      } else {
        controls.push("speak");
        console.log("缩小");
        controls = controls.filter((e) => e !== "ptzclose");
        container.style.width = "100vw";
        container.style.height = "600px";
        container.style.transition = "all 0.3s ease-in-out 0s";
        container.style.transform = "";
        container.style.marginTop = "300px";
        childNodes.style.width = "100%";
        childNodes.style.height = "600px";
        childNodes.style.top = "auto";
        childNodes.style.left = "0";
      }
      console.log(controls);
      this.controls = controls;
      console.log("全屏按钮触发");
    },
    touchstartClick(e) {
      if (this.videoState != 2) {
        return;
      }
      if (this.videoConf.fullScreen) {
        this.moveFill(e);
        return;
      }
      const ptz = this.$refs.ptz;
      let top = e.touches[0].clientY - ptz.getBoundingClientRect().top;
      let left = e.touches[0].clientX - ptz.getBoundingClientRect().left;
      var max_top = ptz.getBoundingClientRect().height;
      var max_left = ptz.getBoundingClientRect().width;
      // 上
      if (top < max_top / 2 && top < left && max_left - left > top) {
        if (this.moveDirection == "1") return;
        this.moveDirection = "1";
        this.movebutton("1", false);
        return;
      }
      // 下
      if (top > max_top / 2 && top > left && max_left - left < top) {
        if (this.moveDirection == "2") return;
        this.moveDirection = "2";
        this.movebutton("2", false);
        return;
      }
      // 左
      if (left < max_left / 2 && top > left && max_left - left > top) {
        if (this.moveDirection == "3") return;
        this.moveDirection = "3";
        this.movebutton("3", false);
        return;
      }
      // 右
      if (left > max_left / 2 && top < left && max_left - left < top) {
        if (this.moveDirection == "4") return;
        this.moveDirection = "4";
        this.movebutton("4", false);
        return;
      }
    },
    touchEnd() {
      this.moveEnd();
    },
    checkScene() {
      console.log("切换场景");
      this.showPicker = true;
    },
    getSubDeviceList() {
      //
      let utoken = this.utoken;
      console.log(utoken, 888);
      let para = {
        SEQID: "1",
        BODY: {
          DID: this.DID,
        },
      };
      getSubDeviceList(para).then((res) => {
        console.log(res);
      });
    },
  },
};
</script>

<style scoped lang="less">
.play-1125 {
  width: 150px;
  height: 150px;
  position: absolute;
  top: 580px;
  left: 50%;
  transform: translate(-50%, -50%);
}
.page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  background-color: #555555;
}
.huif{
  font-size: 36px;
  color: #fff;
}
.ptz {
  width: 430px !important;
  height: 430px;
  position: absolute;
  bottom: 25%;
  left: 50%;
  transform: translateX(-50%);

  .up,
  .down,
  .right,
  .left {
    width: 430px;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    display: none;
  }

  .translucent {
    width: 430px;
    pointer-events: none;
  }
}

.top {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;

  p {
    font-size: 36px;
    font-weight: 400;
    color: #ffffff;
    margin-left: 20px;
  }

  img {
    width: 48px;
    height: 48px;
  }
}

.operation {
  position: absolute;
  width: 100%;
  height: 11%;
  bottom: 2%;
  border-top: 1px solid #8a8a8a;
  display: flex;
  justify-content: space-around;
  align-items: center;

  img {
    width: 60px;
    height: 60px;
  }
}

.speak,
.speak_fill {
  width: 96px !important;
  height: 96px !important;
}

.speak_fill {
  position: fixed;
  top: 50%;
  left: 16px;
  transform: translateY(-50%) translateZ(9999px) rotate(90deg);
  /* transform:  */
}

.ptz_fill {
  position: fixed;
  top: 80px;
  left: 16px;
  transform: translateZ(9999px);
}

.operation_fill {
  /* transform: translateZ(9999px) rotate(180deg);*/
  width: 100%;
  height: 136px;
  position: absolute;
  display: flex;
  bottom: 0;
  left: 0;
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
  justify-content: space-around;
  align-items: center;
  flex-direction: row-reverse;
  z-index: 9999;

  img {
    transform: rotate(90deg);
  }
}

.page_fill {
  background-color: #000000 !important;
}

#container {
  width: 100vw;
  height: 600px;
  margin-top: 300px;
  background-color: black;
}

.loading {
  position: absolute;
  top: 29%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 9990;
}

.loading > p {
  margin-top: 30px;
  font-size: 24px;
  font-weight: 400;
  color: #ffffff;
}

.loading > img {
  animation: loading 4s linear infinite;
}

@keyframes loading {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.downarrow {
  border-radius: 999px;
  border: 1px solid #fff;
  padding: 8px 12px;
}

.picker-model {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 60%;
  background: white;
  transition: all 0.3s linear;
}

//.picker-model /deep/ .van-picker__columns{
//  height: 400px!important;
//}

.picker-model /deep/ .van-ellipsis {
  font-size: 40px;
}

.btn-box {
  //position: absolute;
  //bottom: 30px;
  display: flex;
  justify-content: center;
  margin-top: 30px;

  div {
    font-size: 40px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 220px;
    height: 80px;
  }

  .cancel-btn {
    background: #e2e2e2;
    color: #666666;
    margin-right: 40px;
  }

  .confirm-btn {
    background: #30a4ff;
    color: #fff;
  }
}
// 传感器列表核心样式（丝滑滚动）
.sensor-list {
  position: absolute;
  bottom: 14%;
  left: 0;
  width: 100%;
  height: 160px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  padding-right: 40px; // 预留加载提示空间
  background: rgba(0, 0, 0, 0.6);
  border-top: 1px solid #444;
  border-bottom: 1px solid #444;
  z-index: 998;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch; // 原生惯性滚动（丝滑核心）
  scroll-behavior: smooth; // 平滑滚动

  &::-webkit-scrollbar {
    display: none; // 隐藏滚动条
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
}

.sensor-item {
  flex: 0 0 auto;
  width: 180px;
  height: 190px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  margin-right: 12px;
  padding: 8px;
  color: #fff;
  font-size: 24px;
  text-align: center;

  &:last-child {
    margin-right: 0;
  }

  .sensor-label {
    font-size: 22px;
    margin-bottom: 4px;
    color: #eee;
  }

  .sensor-temp {
    font-size: 28px;
    font-weight: bold;
    padding: 2px 12px;
    border-radius: 4px;
    margin-bottom: 4px;
  }

  .sensor-step {
    font-size: 20px;
    color: #ddd;
  }

  .temp-low {
    background: #1890ff;
    color: #fff;
  }

  .temp-high {
    background: #ff4d4f;
    color: #fff;
  }
}
// 传感器状态样式
.sensor-status {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  // 在线亮灯按钮
  .status-btn.online {
    background: #4CAF50; // 绿色背景
    color: #fff;
    border: none;
    border-radius: 20px;
    padding: 4px 12px;
    font-size: 18px;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;

    &:disabled {
      background: #cccccc;
      color: #666;
      cursor: not-allowed;
    }

    .light-icon {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #ffffff;
      box-shadow: 0 0 8px #4CAF50; // 绿色发光效果（亮灯）
    }
  }

  // 离线文本
  .status-text.offline {
    color: #ff4d4f; // 红色文字
    font-size: 18px;
    text-align: center;
  }
}
.clickable-item {
  cursor: pointer;
  // 鼠标悬浮时高亮
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: scale(1.02); // 轻微放大，增强交互感
    transition: all 0.2s ease;
  }
  // 点击时的按压效果
  &:active {
    transform: scale(0.98);
  }
}
.load-tips {
  flex: 0 0 auto;
  height: 90px;
  display: flex;
  align-items: center;
  color: #ccc;
  font-size: 24px;
  margin-left: 8px;
  padding: 0 10px;
}
</style>
